import React from 'react'
import DAO from '../Components/Dao/Dao';


const Dao = () => {
  return (
    <>
        <DAO />
    </>
  )
}

export default Dao;